module.exports = __webpack_public_path__ + "media/high_school_students/heart-65d55d19.png";